import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import url from "./../../config/url";

Vue.use(Vuex);

const state = {
  status: null,
  exhibitorCollection: [],
  exhibitorFilteredCollection: [],
  exhibitors: [],
  pages: 0,
  exhibitorPerPage: 30,
  selectedPage: 1,
};

const mutations = {
  initialExhibitor(state, data) {
    // eslint-disable-next-line no-debugger
    debugger;
    state.status = "All Exhibitor Data";
    state.selectedPage = 1;

    if (Array.isArray(data)) {
      state.exhibitorCollection = data;
      state.exhibitorFilteredCollection = data;
      state.pages = Math.ceil(
        state.exhibitorCollection.length / state.exhibitorPerPage
      );
      state.exhibitors = state.exhibitorCollection.slice(
        0,
        state.exhibitorPerPage
      );
    } else {
      state.exhibitorCollection = data.Result;
      state.exhibitorFilteredCollection = data.Result;
      state.pages = Math.ceil(
        state.exhibitorCollection.length / state.exhibitorPerPage
      );
      state.exhibitors = state.exhibitorCollection.slice(
        0,
        state.exhibitorPerPage
      );
    }
  },
  filteredExhibitor(state, data) {
    // eslint-disable-next-line no-debugger
    debugger;
    state.status = "Filtered Exhibitor data";
    state.exhibitorCollection = data;
    state.exhibitorFilteredCollection = data;
    state.pages = Math.ceil(
      state.exhibitorFilteredCollection.length / state.exhibitorPerPage
    );
    state.exhibitors = state.exhibitorFilteredCollection.slice(
      0,
      state.exhibitorPerPage
    );
    state.selectedPage = 1;
  },
  PaginatedExhibitor(state, data) {
    state.status = "Paginated Exhibitors";
    state.exhibitors = data;
  },
  AlphaNumericExhibitor(state, data) {
    state.selectedPage = 1;
    state.status = "Alphanumeric Exhibitors";
    state.exhibitorFilteredCollection = data;
    state.exhibitors = state.exhibitorFilteredCollection.slice(
      0,
      state.exhibitorPerPage
    );
    state.pages = Math.ceil(
      state.exhibitorFilteredCollection.length / state.exhibitorPerPage
    );
  },
  ActivePage(state, pageNumber) {
    state.selectedPage = pageNumber;
  },
};

const actions = {
  exhibitorInitialList: function ({ commit }, eventname) {
  
    // eslint-disable-next-line no-debugger
    debugger;
    let apiUrl =
      eventname === "wuc"
        ? url.initial_load_api_WUC
        : url.initial_load_api(eventname);

    axios
      .get(apiUrl)
      .then((response) => {
        commit("initialExhibitor", response.data);       
      })   
      .catch();
  },
  exhibitorPaginatedList: function ({ commit }, pageNum) {
    commit(
      "PaginatedExhibitor",
      state.exhibitorFilteredCollection.slice(
        (pageNum - 1) * state.exhibitorPerPage,
        pageNum * state.exhibitorPerPage
      )
    );
  },
  exhibitorAlphabeticList: function ({ commit }, alphabet) {
    commit(
      "AlphaNumericExhibitor",
      state.exhibitorCollection.filter(
        (exhibitor) =>
          exhibitor.CompanyName[0].toLowerCase() == alphabet.toLowerCase()
      )
    );
  },
  exhibitorNumericList: function ({ commit }) {
    commit(
      "AlphaNumericExhibitor",
      state.exhibitorCollection.filter(
        (exhibitor) => exhibitor.CompanyName[0] >= 0
      )
    );
  },
  exhibitorViewAllList: function ({ commit }) {
    commit(
      "AlphaNumericExhibitor",
      state.exhibitorCollection.filter((exhibitor) => exhibitor)
    );
  },
  activePaging: function ({ commit }, pageNumber) {
    commit("ActivePage", pageNumber);
  },
};

export default {
  state,
  mutations,
  actions,
};
